// extracted by mini-css-extract-plugin
export default {"wrap":"G_cG","navItem":"G_bJ"};